import '@hotwired/turbo-rails'

document.addEventListener("turbo:load", function () {
  $("#search_date_from").datepicker({
    dateFormat: "dd/mm/yy",
    changeMonth: true,
    changeYear: true,
    firstDay: 1,
    autosize: false
  });

  $("#search_date_to").datepicker({
    dateFormat: "dd/mm/yy",
    changeMonth: true,
    changeYear: true,
    firstDay: 1,
    autosize: false
  });

  $("#search_started_date_from").datepicker({
    dateFormat: "dd/mm/yy",
    changeMonth: true,
    changeYear: true,
    firstDay: 1,
    autosize: false
  });

  $("#search_started_date_to").datepicker({
    dateFormat: "dd/mm/yy",
    changeMonth: true,
    changeYear: true,
    firstDay: 1,
    autosize: false
  });

  $(".mslTooltip").tooltip({
    items: ":hover",
    position: {
      my: "center bottom-20",
      at: "center top",
      using: function (position, feedback) {
        $(this).css(position);
        $("<div>")
          .addClass("arrow")
          .addClass(feedback.vertical)
          .addClass(feedback.horizontal)
          .appendTo(this);
      }
    }
  });
});